export default function Disclaimer() {
  return (
    <section id="about" className="scroll-mt-4 bg-[#faf5eb]">
      <div className="mx-auto max-w-[1200px] px-4 py-14 md:px-6 md:py-20">
        <div className="flex flex-col gap-2">
          <h4 className="flex items-center gap-2 text-[11px] tracking-[0.35em] text-[#b1401f]">
            <i className="ri-shield-check-line" aria-hidden="true"></i>
            关于本站 · 阅读约定
          </h4>
          <h3 className="font-display mt-3 text-2xl font-black text-[#1a160e] md:text-3xl">
            翻旧账之前，先看这一页
          </h3>
        </div>

        <div className="mt-8 grid gap-5 lg:grid-cols-3">
          <article className="border border-[#e3d7bd] bg-[#f3ead8] p-6">
            <i className="ri-error-warning-line text-2xl text-[#b1401f]" aria-hidden="true"></i>
            <h3 className="mt-4 text-base font-bold text-[#1a160e]">本站为虚构整理展示</h3>
            <p className="mt-2 text-sm leading-6 text-[#6f6552]">
              呱呱黑料所整理的历史旧账、早年言论、陈年往事与黑历史后续均为虚构编排，不指向任何真实人物或事件，请勿据此断言现实。
            </p>
          </article>
          <article className="border border-[#e3d7bd] bg-[#f3ead8] p-6">
            <i className="ri-chat-check-line text-2xl text-[#b1401f]" aria-hidden="true"></i>
            <h3 className="mt-4 text-base font-bold text-[#1a160e]">不做断章，只做对账</h3>
            <p className="mt-2 text-sm leading-6 text-[#6f6552]">
              收录条目尽量找回原始出处与完整语境，删减、剪辑带来的误差会单独标注，避免一段早年言论被单独拎出来误导阅读。
            </p>
          </article>
          <article className="border border-[#e3d7bd] bg-[#f3ead8] p-6">
            <i className="ri-pencil-ruler-line text-2xl text-[#b1401f]" aria-hidden="true"></i>
            <h3 className="mt-4 text-base font-bold text-[#1a160e]">纠错与补充</h3>
            <p className="mt-2 text-sm leading-6 text-[#6f6552]">
              如果你发现卷宗里的时间线、出处或归档号有误，可以提交纠错备注；补录素材请附上可回溯的来源，我们会逐条校对后入档。
            </p>
          </article>
        </div>

        <div className="mt-8 flex flex-col gap-3 sm:flex-row">
          <button
            type="button"
            className="inline-flex cursor-pointer items-center justify-center gap-2 border border-[#1a160e] px-5 py-3 text-sm font-medium whitespace-nowrap transition hover:bg-[#1a160e] hover:text-[#faf5eb]"
          >
            <i className="ri-message-3-line text-base" aria-hidden="true"></i>
            提交纠错备注
          </button>
          <button
            type="button"
            className="inline-flex cursor-pointer items-center justify-center gap-2 border border-[#1a160e] px-5 py-3 text-sm font-medium whitespace-nowrap transition hover:bg-[#1a160e] hover:text-[#faf5eb]"
          >
            <i className="ri-upload-2-line text-base" aria-hidden="true"></i>
            补充可回溯素材
          </button>
        </div>
      </div>
    </section>
  );
}